import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';
import { PLATFORM_HEADERS } from './platform';

const BASE = import.meta.env.VITE_125_PLATFORM_PUBLIC_BASE_URL;

export interface GetGoogleLocationsParams {
	page?: number;
	pageSize?: number;
	/** Name, address or postcode filter, applied in the query so the totals describe it. */
	search?: string;
}

const response = {
	// GET /listings/google-locations: internal, cross-tenant, offset pagination.
	// Same rule as getCompanies: absent params are omitted rather than sent, because
	// `params` is fed to URLSearchParams, which would send a literal "undefined".
	async getGoogleLocations({
		page,
		pageSize,
		search,
	}: GetGoogleLocationsParams = {}): Promise<any> {
		const term = search?.trim();
		const query: Record<string, string> = {
			page: String(page ?? 1),
			page_size: String(pageSize ?? 50),
		};

		if (term) {
			query.search = term;
		}

		return await api(
			HTTP_TYPES.GET,
			`${BASE}/listings/google-locations`,
			undefined,
			query,
			'application/json',
			'v1',
			{ ...PLATFORM_HEADERS },
		);
	},
};

export default response;
